<mat-form-field
  appearance="outline"
  [color]="model.getAdditional('color', 'primary')"
  [formGroup]="group"
  [hideRequiredMarker]="model.getAdditional('hideRequiredMarker', false)"
  [ngClass]="getClass('grid', 'control')"
>
  @if (model.label) {
  <ng-container ngProjectAs="mat-label">
    <mat-label [innerHTML]="model.label"></mat-label>
  </ng-container>
  } @if (model.prefix) {
  <span matPrefix [innerHTML]="model.prefix"></span>
  }
  <span [innerHTML]="displayInput" class="display-input-date"></span>
  <input
    matInput
    [matDatepickerFilter]="filterDate"
    [autofocus]="model.autoFocus"
    [formControlName]="model.id"
    [id]="id"
    [max]="maxDateOverride || maxDate"
    [matDatepicker]="matDatepicker"
    [min]="minDate"
    [name]="model.name"
    [ngClass]="getClass('element', 'control')"
    [placeholder]="model.placeholder"
    readonly
    [required]="model.required"
    (blur)="onBlur($event)"
    (dateChange)="onChange($event)"
    (dateInput)="onCustomEvent($event, 'dateInput')"
    (focus)="onFocus($event)"
    style="display: none"
  />

  @if (model.suffix) {
  <span matSuffix [innerHTML]="model.suffix"></span>
  } @if (model.hint !== null) {
  <mat-hint align="start" [innerHTML]="model.hint"></mat-hint>
  }

  <mat-datepicker-toggle matSuffix [for]="matDatepicker">
    @if (!matDatepicker.opened) {
    <mat-icon matDatepickerToggleIcon class="material-icons">calendar_today</mat-icon>
    } @if (matDatepicker.opened) {
    <mat-icon matDatepickerToggleIcon style="font-size: 26px; position: relative; top: 6px"
      >keyboard_arrow_down</mat-icon
    >
    }
  </mat-datepicker-toggle>

  <mat-datepicker
    #matDatepicker
    [opened]="model.getAdditional('opened', false)"
    [startAt]="model.focusedDate"
    [startView]="model.getAdditional('startView', 'month')"
    [touchUi]="model.getAdditional('touchUi', false)"
    (closed)="onCustomEvent($event, 'closed')"
    (monthSelected)="onCustomEvent($event, 'monthSelected')"
    (opened)="onCustomEvent($event, 'opened')"
    (yearSelected)="onCustomEvent($event, 'yearSelected')"
  ></mat-datepicker>

  @for (message of errorMessages; track message) {
  <mat-error>{{ message }}</mat-error>
  }
</mat-form-field>
